import type { Thing } from 'schema-dts';
import { MIME_TYPE } from '@libs/core';
import type { JsonLdProps } from './types';

export function JsonLd<T extends Thing>({ json, ...props }: JsonLdProps<T>) {
    return <script {...props} type={MIME_TYPE.jsonld} dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}
